module.exports = __webpack_public_path__ + "static/img/bg_industry.684ba2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_industry.png
// module id = y5Nw
// module chunks = 192